export const Marquee = ({ items, className = "" }) => {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`whitespace-nowrap font-display text-2xl sm:text-4xl font-bold uppercase tracking-wide px-6 text-ink`}>
            {item}
          </span>
          <span className="h-2.5 w-2.5 rotate-45 bg-signal inline-block" />
        </span>
      ))}
    </div>
  );

  return (
    <div className={`overflow-hidden bg-amber py-4 sm:py-6 ${className}`} data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};

export default Marquee;
